export class Ordered {

    //implementar tax e valor minus tax
    public id: string;
    public date: Date;
    public type: string = ""; // CreditCard, Billet  

    public product_id: string;
    public product_name: string;

    public member_id: string;
    public member_name: string;
    public member_cpf: string;
    public member_cellPhone: string;
    public member_email: string;
    public member_debit: number;

    public category_id: string;
    public category_name: string;

    public lot_id: any;
    public until_date: string;
    
    public value: number;
    public total: number;
    public tax: number;
    public total_minus_tax: number = 0;
    public payAsOverdue: boolean = false;
    public discount: number;

    public card_brand: string = "";
    public card_number: string;
    public card_installments: number; //parcelas
    public card_softdescriptor: string // descrição fatura = SBCCV
    public card_holder: string; // portador
    public card_expirationDate: string;
    public card_securityCode: string;

    public billet_brand: string;
    public billet_name: string;
    public billet_identity: string;
    public billet_street: string;
    public billet_number: string;
    public billet_complement: string;
    public billet_zipCode: string;
    public billet_district: string;
    public billet_city: string;
    public billet_state: string;
    public billet_country: string;

    public payment_date: Date;
    public payment_type: string; //unificar com type
    public paymentId: string = "";
    public Tid: string = "";
    public returnCode: string = "";
    public proofOfSale: string = "";
    public authorizationCode: string = "";

    public cash_operator: any;
    public origin: string;

    public staff: boolean = false;

    public refund: any;

    public nonMemberCategory_id: string;
    
    public evventSlots: any = "";

    public event: any;
    public topic_id: string;
    public topic_name: string;
    public topic_text1: string;
    public topic_text2: string;
    public topic_text3: string;

    public receiptUrl: string;
    
    constructor() { }
    
}